import type { PostgrestError } from '@supabase/supabase-js';

/**
 * Uniform error thrown by the data-access layer (services).
 * Gives callers a consistent shape instead of raw Postgrest errors.
 */
export class ServiceError extends Error {
  constructor(
    message: string,
    readonly code?: string,
  ) {
    super(message);
    this.name = 'ServiceError';
  }
}

/**
 * Unwrap a Supabase query result, throwing a {@link ServiceError} on failure.
 * Use inside service functions so every caller gets the same error handling.
 *
 *   const leads = unwrap(await supabase.from('leads').select('*'), 'Leads laden');
 */
export function unwrap<T>(
  result: { data: T | null; error: PostgrestError | null },
  context: string,
): T {
  if (result.error) {
    throw new ServiceError(`${context}: ${result.error.message}`, result.error.code);
  }
  return result.data as T;
}
